export default "__VITE_ASSET__5wk$hLKM__"